import {ComponentType} from 'react'
import dynamic from 'next/dynamic'

export default function getLoyaltyProgram(props) {
  const {loyaltyType} = props

  const loyaltyLayouts: {[key: string]: () => ComponentType} = {
    spoonity: () => dynamic(() => import('./spoonity')),
    comoMX: () => dynamic(() => import('./comoMX')),
    loyalsenseMX: () => dynamic(() => import('./loyalsenseMX')),
    paybackMX: () => null //Is deprecated until further notice dynamic(() => import('./paybackMX'))
  }

  const LoyaltyComponent = loyaltyLayouts[loyaltyType]()
  if (!LoyaltyComponent) return null
  return <LoyaltyComponent {...props} />
}
